import { dmxInputFields, dmxVariables, dmxFields } from './dmxGqlChunks';
import { getCreateRouteId, getDetailQueryName, getDetailRouteId, getListRouteId } from './utils';
export const buildRoutesConfig = (tinkerConfig, nonTranslatableResourceStrings) => {
    const layerRoutes = [];
    tinkerConfig.mapLayers.edges
        .filter((mapLayer) => mapLayer.node.isInLayerSwitcher)
        .forEach((mapLayerEdge) => {
        const mapLayer = {
            ...mapLayerEdge.node,
            nameId: mapLayerEdge.node.nameId.replaceAll('-', '_'),
        };
        const mapLayerId = mapLayer.nameId;
        nonTranslatableResourceStrings[`Idvfkodsuffix${mapLayerId}Connection`] = mapLayer.title;
        layerRoutes.push({
            id: getListRouteId(mapLayerId),
            auth: mapLayer.mapService.isAuth,
            path: `/:idDoc/${mapLayerId}`,
            query: `query query${mapLayerId}
            ($idDoc: Int! @hidden) {
                aktualizacniData${mapLayerId}List(filters: {
                  docId: $idDoc,
                  idvfkodsuffix: "${mapLayerId}"
                }) ${mapLayer.canInsert ? `@create(route: "${getCreateRouteId(mapLayerId)}")` : ''} {
                  edges {
                    cursor
                    node
                    @detail(route: "${getDetailRouteId(mapLayerId)}")
                    {
                      id @hidden
                      geometrie @ewkt(projection: "EPSG:5514")
                      iddtm
                      idprvek
                      urovenumisteni
                      zmena
                      ${dmxFields}
                    }
                  }
                }
              }
            `,
        });
        const queries = [];
        nonTranslatableResourceStrings[`Idvfkodsuffix${mapLayerId}`] =
            `Detail prvku (${mapLayer.title})`;
        queries.push(`
          query ${getDetailQueryName(mapLayerId)}($id: ID!, $idDoc: Int!) {
            feature: aktualizacniData${mapLayerId}(filters: {
              docId: $idDoc,
              id: $id
            })
              {
                ... @group {
                  id @hidden
                  zmena
                  urovenumisteni
                  geom: geometrie @ewkt(projection: "EPSG:5514", layer: "${mapLayerId}", pointZoomLevel: 22)
                  iddtm
                  ${dmxFields}
                }
              }
            }
        `);
        if (mapLayer.canUpdate) {
            queries.push(`
          mutation update(
            $id: auto,
            $idDoc: Int! @hidden,
            $zmena: TypZmeny,
            $geom: auto,
            $iddtm: auto @select(query: "iddtmSelectUpdate"),
            $urovenumisteni: auto,
            ${dmxVariables}
          ) @layer(id: "${mapLayerId}")
          {
            updateAktualizacniDataIdvfkodsuffix${mapLayerId}(
              input: {
                id: $id,
                docId: $idDoc,
                common: {
                  geometrie: $geom
                  iddtm: $iddtm
                  idprvek: $id
                  urovenumisteni: $urovenumisteni,
                }
                attributes: {
                  ${dmxInputFields}
                }
              }
            ) {
              id
            }
          }

          query iddtmSelectUpdate {
            katalogDtmList(filters: {
              idvfkodsuffix: "${mapLayerId}"
            }) {
              edges {
                node {
                  iddtm @hidden
                  popisdtm
                  #skupina
                  #kategorie
                }
              }
            }
          }
            `);
        }
        if (mapLayer.canDelete) {
            queries.push(`
          mutation delete($id: ID!, $idDoc: Int!)
            @redirect(route: "${getListRouteId(mapLayerId)}", history: REPLACE)
            @layer(id: "${mapLayerId}")
          {
            deleteAktualizacniData(
              id: $id,
              docId: $idDoc,
              idvfkodsuffix: "${mapLayerId}"
            ) {
              id
            }
          }`);
        }
        if (queries.length) {
            layerRoutes.push({
                id: getDetailRouteId(mapLayerId),
                auth: mapLayer.mapService.isAuth,
                path: `/:idDoc/${mapLayerId}/:id`,
                query: queries.join(' '),
                context: {
                    parentRouteId: getListRouteId(mapLayerId),
                },
                defaultSize: 'small',
            });
        }
        if (mapLayer.canInsert) {
            const createRouteId = mapLayer.canInsert ? getCreateRouteId(mapLayerId) : undefined;
            if (createRouteId) {
                nonTranslatableResourceStrings[`create${mapLayerId}`] = `Nový prvek (${mapLayer.title})`;
                const createMutation = `
            mutation create${mapLayerId}(
              $urovenumisteni: auto
              $idDoc: Int! @hidden
              $iddtm: auto @select(query: "iddtmSelect")
              $idprvek: auto
              ${dmxVariables}
              $geom: auto @ewkt(projection: "EPSG:5514", geometryType: ${mapLayer.mapService.geometryType}))
              @layer(id: "${mapLayerId}")
              @redirect(route: "${getDetailRouteId(mapLayerId)}")
            {
              createAktualizacniDataIdvfkodsuffix${mapLayerId}(
                input: {
                  attributes: {
                    ${dmxInputFields}
                  }
                  common: {
                    geometrie: $geom
                    iddtm: $iddtm
                    idprvek: $idprvek
                    urovenumisteni: $urovenumisteni
                  }
                  docId: $idDoc
                }
              ) {
                id
                idprvek
              }
            }

            query iddtmSelect {
              katalogDtmList(filters: {
                idvfkodsuffix: "${mapLayerId}"
              }) {
                edges {
                  node {
                    iddtm @hidden
                    popisdtm
                  }
                }
              }
            }
          `;
                layerRoutes.push({
                    id: createRouteId,
                    auth: mapLayer.mapService.isAuth,
                    path: `/:idDoc/${mapLayerId}/novy`,
                    query: createMutation,
                    context: {
                        parentRouteId: getListRouteId(mapLayerId),
                    },
                    defaultSize: 'small',
                });
            }
        }
    });
    return layerRoutes;
};
//# sourceMappingURL=buildRoutesConfig.js.map